import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import watch from './attrs/watch'
import ListHeader from '@/components/ListHeader/Index'

export default {
  name: 'ModalsList',
  data,
  methods,
  mounted,
  watch,
  components: {
    ListHeader
  }
}
